const uuid = require('uuid');
import React from 'react';
import PropTypes from 'prop-types';
const _ = {
    find: require('lodash/find'),
    findIndex: require('lodash/findIndex'),
    forEach: require('lodash/forEach'),
    reject: require('lodash/reject'),
};


const Globals = require('../../../../app/globals');

//const ShortCourseEditorStore = require('../../stores/ShortCourseEditorStore');
const ShortCourseEditorActions = require('../../actions/ShortCourseEditorActions');

const ActivityActions = require('../../actions/ActivityActions');
const ActivityStore = require('../../stores/activity_store_reflux');

import LoadingSpinner from '../loading/LoadingSpinner';

const propTypes = {
    doc: PropTypes.object.isRequired,
    activities: PropTypes.array.isRequired,
    templates: PropTypes.object, // keyed by template id
}

const ContentAlertType = {
    NOT_LATEST_VERSION: 'NOT_LATEST_VERSION',
    MISSING_ACTIVITY: 'MISSING_ACTIVITY',
};

class ContentUpdater extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.requestInitialState(props);
        this.unsubscribes = [ActivityStore.listen(this.onActivityStoreChange)];
        this.content_timers = [];
    }
    
    requestInitialState=(props)=>{
        //console.log("ContentUpdater requestInitialState props.activities[0]:",props.activities[0]);
        let pendingData = [];
        let act_data = [];
        let missing_activities = [];
        const storeState = ActivityStore.getState();
        
        _.forEach(props.doc.content_blocks,(cb)=>{
            if (cb.type === Globals.short_course.content_block_type.ACTIVITY) {
                // console.log(`processing content block activity ${cb.nova_activity_id}, version ${cb.activity_version}`,cb);
                let activity_query = {activity_id: cb.nova_activity_id, version: cb.activity_version};
                
                
                let store_activity = this.getStoreActivity(storeState,{activity_id: cb.nova_activity_id});
                if (!store_activity) {
                    if (missing_activities.indexOf(cb.nova_activity_id) < 0) {
                        missing_activities.push(cb.nova_activity_id);
                    }
                    return;
                }
                
                let activity_entry = _.find(act_data,activity_query);
                if (!activity_entry) {
                    activity_entry = {
                        ...activity_query,
                        latest_published_version: store_activity.latest_published_version,
                        cb_hashes: [],
                    };
                    act_data.push(activity_entry);
                }
                activity_entry.cb_hashes.push(cb.hash);

                if (!store_activity.latest_published_version) {
                    let activityId = store_activity.id;
                    let novaActId = cb.nova_activity_id;
                    if (!_.find(pendingData,{activityId})) {
                        console.log(`ContentUpdater requesting more info for novaActId ${novaActId} ${store_activity.title}`); // FIXME: remove debug spam
                        let actionId = uuid.v4();
                        ActivityActions.getActivity(actionId, {activityId});
                        pendingData.push({actionId,activityId,novaActId});
                    }
                }
            }
        }); // for content blocks

        return { 
            act_data, 
            missing_activities,
            pendingData,
            status_message: 'Checking status',
            idle: false
        };
    }
    
    componentDidMount() {
        if (!this.state.pendingData.length) {
            this.analyzeContent();
        }
    }
    
    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
        this.content_timers.forEach((entry)=>{
            clearTimeout(entry.timer_id);
        });
    }
    
    getStoreActivity=(storeState,query)=>{
        let store_activity;
        _.forEach(storeState.activities,(projActivities,proj_id)=>{
            store_activity = _.find(projActivities, query);
            if (store_activity) {
                return false;
            }
        });
        return store_activity;
    }
    
    onActivityStoreChange=(storeState)=>{
        if (storeState.action) {
            let pendingData = this.state.pendingData.slice();
            const index = _.findIndex(pendingData, { actionId: storeState.action.id });
            const entry = this.state.pendingData[index];
            if (entry) {
                // let act = _.find(props.activities, {activity_id: entry.activity_id});
                let store_activity = this.getStoreActivity(storeState,{activity_id:entry.novaActId});
                let pendingData = this.state.pendingData.slice().splice(index, -1);
                let act_data = this.state.act_data.slice();
                if (store_activity) {
                    _.forEach(act_data,(activity)=>{
                        if (activity.activity_id === entry.novaActId) {
                            activity.latest_published_version = store_activity.latest_published_version;
                        }
                    });
                }
                this.setState({act_data, pendingData},()=>{
                    if (!pendingData.length) {
                        this.analyzeContent();
                    }
                });
            }
        }
    }
    
    startContentAlertCloseTimer=(entry)=>{
        let alert_id = entry.alert_id;
        let timer_id = setTimeout(()=>{
            this.content_timers = _.reject(this.content_timers,{alert_id});
            this.removeAlert(entry);
        },1000);
        this.content_timers.push({alert_id,timer_id});
    }

    removeAlert=(entry)=>{
        // remove the entry from our state
        let idle = false;
        let content_alerts = _.reject(this.state.content_alerts,{alert_id: entry.alert_id});
        if (!content_alerts.length) {
            console.log("no more content alerts"); // FIXME: remove debug spam
            idle = true;
        }
        this.setState({content_alerts,idle});
    }

    resolveContentAlert=(entry,acceptRecommendation)=>{
        if (acceptRecommendation) {
            switch(entry.type) {
                case ContentAlertType.NOT_LATEST_VERSION:
                    ShortCourseEditorActions.updateActivityVersion(uuid.v4(), entry.novaActId, entry.latest_published_version);
                    entry.accept_text = 'updating...';
                    entry.cancel_text = '';
                    entry.disabled = true;
                    this.startContentAlertCloseTimer(entry);
                    return;
                case ContentAlertType.MISSING_ACTIVITY:
                    ShortCourseEditorActions.removeContentBlock(uuid.v4(), entry.novaActId);
                    entry.accept_text = 'removing...';
                    entry.cancel_text = '';
                    entry.disabled = true;
                    this.startContentAlertCloseTimer(entry);
                    return;
                    
                default:
                    console.log("Error: entry type " + entry.type);
            }
        }
        this.removeAlert(entry);
    }

    analyzeContent=()=>{
        const storeState = ActivityStore.getState();
        let content_alerts = [];
        _.forEach(this.state.act_data, (entry)=>{
            if (!entry.latest_published_version) {
                console.log(`Error: failed to obtain latest_published_version for activity ${entry.activity_id}`);
                return; // skip
            }
            if (entry.version !== entry.latest_published_version) {
                if (!_.find(content_alerts,{novaActId:entry.activity_id})) {
                    let store_activity = this.getStoreActivity(storeState,{activity_id:entry.activity_id});
                    if (!store_activity) {
                        console.log("Error: missing activity for nova_activity_id " + entry.activity_id); 
                        return; // skip
                    }
                    content_alerts.push({
                        alert_id: uuid.v4(), 
                        type: ContentAlertType.NOT_LATEST_VERSION,
                        text: `Activity ${store_activity.title} is using v${entry.version}.  The latest is v${entry.latest_published_version}`,
                        accept_text: 'update',
                        cancel_text: 'no change',
                        novaActId: entry.activity_id,
                        latest_published_version: entry.latest_published_version,
                    });
                }
            }
        });
        
        _.forEach(this.state.missing_activities, (novaActId)=>{
            content_alerts.push({
                alert_id: uuid.v4(), 
                type: ContentAlertType.MISSING_ACTIVITY,
                text: `Activity ${novaActId} not found (deleted)`,
                accept_text: 'remove',
                cancel_text: 'ignore error',
                novaActId: novaActId,
            });
        });
        
        let idle = content_alerts.length ? false : true;
        let status_message = '';
        if (idle) {
            console.log("no content alerts"); // FIXME: remove debug spam
        }
        this.setState({content_alerts, idle, status_message})
    }

    render() {
        if (this.state.idle) {
            return null;
        }
        let contentAlertsSection = null;
        if (this.state.content_alerts && this.state.content_alerts.length) {
            let alertEntries = [];
            _.forEach(this.state.content_alerts,(entry)=>{
                alertEntries.push(
                    <div className="alert-line" key={entry.alert_id}>
                        <span>{entry.text}</span>
                        <button className="accept-button" disabled={entry.disabled} onClick={()=>{this.resolveContentAlert(entry,true)}}>{entry.accept_text}</button>
                        {entry.cancel_text ?
                        <button className="cancel-button" onClick={()=>{this.resolveContentAlert(entry,false)}}>{entry.cancel_text}</button>
                        : null }
                    </div>
                );
            });
            contentAlertsSection = (
                <div className="content-alerts">
                    {alertEntries}
                </div>
            );
        }
        
        return (
            <div className="short-course-editor-content-updater">
                {this.state.status_message ? 
                <div>
                    <span>{this.state.status_message}</span>
                    <LoadingSpinner />
                </div>
                : null }
                {contentAlertsSection}
            </div>
        );
    }
};

export default ContentUpdater;